<div class="holder">
  <div class="range" #range="" [ngClass]='"bg-"+bgTemplate'>
    <div class="marker" #slider="">
      @if (value >= 0) {
        <img [src]='"/assets/images/progress-"+value+".png"' [attr.data-index]="value" [ngClass]="{ 'anim-zoom': enableAnimation }" />
      }
    </div>
  </div>
</div>
@if (fraction) {
  <div class="stages">
    @for (item of stages; track item; let i = $index) {
      <span [ngStyle]='{"width": fraction + "px"}' [ngClass]='{ "active": i == value }'>{{item}}</span>
    }
  </div>
}